import * as c from '../../constants.js';
import * as cc from '../../common/context/constants.js';
import {reason} from '../../reason.js';

export const contextDomainUri = c.contextDomainUri;
export const failure = cc.failure(contextDomainUri);
export const reasonPeerRemoved = reason(`${contextDomainUri}.peer-removed`, "Peer has been removed");
